module.exports = __webpack_public_path__ + "img/symbol_8.17308542.png";